import { useState, useCallback, FC } from 'react'
import { searchAttriutes } from '@services/attributeService'
import { TreeSelect, TreeSelectProps } from 'antd'

export function getAggregationsFeatureIds(aggregations): string[] | null | undefined {
  if (!Array.isArray(aggregations)) return null
  const featureIds = aggregations.find(a => a.name === 'featureIds')
  if (featureIds) {
    return featureIds.buckets?.map(b => b.name)
  }
  return null
}

function searchAttributesProcess(ids: string[]) {
  return new Promise((resolve, reject) => {
    const specialValueIds = ids.filter(id => id.indexOf('_') === -1)
    if (specialValueIds.length) {
      searchAttriutes(specialValueIds)
        .then(res => {
          const parentIds = new Set<string>()
          if (res.data.items) {
            res.data.items.forEach(item => {
              if (item.parent_id) {
                parentIds.add(item.parent_id)
              }
            })
            const requestIds = ids.concat(Array.from(parentIds))
            searchAttributesNormalProcess(requestIds)
              .then((items: any) => {
                resolve(items)
              })
              .catch(e => {
                reject(e)
              })
          }
        })
    } else {
      searchAttributesNormalProcess(ids)
        .then((items: any) => {
          resolve(items)
        })
        .catch(e => {
          reject(e)
        })
    }
  })
}

function searchAttributesNormalProcess(ids: string[]) {
  return new Promise((resolve, reject) => {
    // normal item ids
    const itemIds = ids.filter(id => id.indexOf('_') !== -1).map(id => id.split('_')[0])
    const itemIdGroup = Array.from(new Set(itemIds))
    // console.log(itemIdGroup)
    const requestIds = ids.concat(itemIdGroup)
    searchAttriutes(requestIds)
      .then(res => {
        setTimeout(() => {
          if (!res.data.items) return
          const items = res.data.items.filter(i => i.type === 1).map(item => {
            return {
              id: item.id,
              title: item.value,
              value: item.id,
              key: item.id,
              selectable: false,
              children: [],
            }
          })
          const values = res.data.items.filter(i => i.type === 0)
          values.forEach(v => {
            const matchIndex = items.findIndex(item => item.id === v.parent_id)
            if (matchIndex !== -1) {
              items[matchIndex].children.push({
                title: `${v.value}(${v.id})`,
                value: v.id,
                key: v.id,
                selectable: true,
                isLeaf: true,
              })
            }
          })
          const unRecognizedIds = ids.filter(id => res.data.items.findIndex(v => v.id === id) === -1)
          if (unRecognizedIds?.length) {
            items.push({
              title: 'Unrecognized',
              value: -1,
              children: unRecognizedIds.map(v => {
                return {
                  title: v,
                  value: v,
                  key: v,
                  selectable: true,
                  isLeaf: true,
                }
              })
            })
          }
          console.log(items)
          resolve(items)
        }, 100)
      })
      .catch(e => {
        console.error(e)
        reject(e)
      })
  })
}

// todo 随着属性和属性项的增加，后续可能要改成二级展开再加载 values
// with fixed ids
const AttributeValueSelect: FC<TreeSelectProps & { ids: string[] | null | undefined }> = (props) => {
    const {
        ids,
        value,
        onChange,
        placeholder,
        multiple = true,
        showSearch = true,
        allowClear = true,
        notFoundContent,
        ...properties
    } = props
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const onSearchAttributes = useCallback(ids => {
      if (ids?.length) {
        setLoading(true)
        searchAttributesProcess(ids)
          .then((items: any) => {
            setOptions(items)
            setLoading(false)
          })
          .catch(e => {
            setLoading(false)
            setOptions(ids.map(id => ({ label: id, value: id })))
          })
      } else {
        setOptions([])
        setLoading(false)
      }
    }, [])

    return (
      <TreeSelect
        value={value}
        showSearch={showSearch}
        allowClear={allowClear}
        placeholder={placeholder}
        multiple={multiple}
        onChange={onChange}
        onDropdownVisibleChange={(open) => {
          if (open) {
            onSearchAttributes(ids)
          }
        }}
        dropdownMatchSelectWidth={false}
        dropdownStyle={{ maxWidth: 400, minWidth: 250, maxHeight: 800, overflow: 'auto' }}
        treeData={options}
        notFoundContent={notFoundContent}
        loading={loading}
        treeCheckable
        style={{ width: 200 }}
        {...properties}
      >
    </TreeSelect>
  )
}

export default AttributeValueSelect
